/* Asteria V23: explicit transition from anonymous wholesale preview to the existing retail storefront. */
(() => {
  'use strict';
  const switchLinks = document.querySelectorAll('[data-ae-switch-retail]');
  if (!switchLinks.length) return;
  for (const link of switchLinks) {
    link.addEventListener('click', async event => {
      event.preventDefault();
      if (link.dataset.aeBusy === 'true') return;
      link.dataset.aeBusy = 'true';
      link.setAttribute('aria-busy', 'true');
      const defaultText = link.textContent;
      link.textContent = 'Opening retail…';
      try {
        const cartRoute = (link.dataset.aeCartUrl || '/cart').replace(/\/$/, '');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        let response;
        try {
          response = await fetch(cartRoute + '/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({attributes:{ae_shopping_mode:'retail'}}),
            signal: controller.signal
          });
        } finally { clearTimeout(timeout); }
        if (!response.ok) throw new Error('retail-mode-update-failed');
        const cart = await response.json();
        if (cart.attributes?.ae_shopping_mode !== 'retail') throw new Error('retail-mode-not-confirmed');
        try { sessionStorage.setItem('ae_global_entry_choice', 'retail'); } catch (_) {}
        const url = new URL(window.location.href);
        const root = window.Shopify?.routes?.root || '/';
        // Retail is the normal home page, not the dedicated Wholesale application page.
        if (/\/pages\/wholesale\/?$/i.test(url.pathname)) url.pathname = root;
        url.searchParams.delete('ae_entry');
        url.searchParams.delete('ae_mode');
        // Keep preview_theme_id and all other preview context intact while testing.
        const destination = window.AEPreviewContext?.withPreviewContext(url.href) || url;
        window.location.assign(destination.href);
      } catch (error) {
        link.dataset.aeBusy = 'false';
        link.removeAttribute('aria-busy');
        link.textContent = defaultText;
        let status = link.parentElement?.querySelector('[data-ae-retail-switch-status]');
        if (!status) {
          status = document.createElement('p');
          status.setAttribute('role', 'alert');
          status.setAttribute('data-ae-retail-switch-status', '');
          status.style.cssText = 'font-size:13px;color:#fff0ce;margin:8px 0 0;';
          link.insertAdjacentElement('afterend', status);
        }
        status.textContent = 'Could not switch to retail. Please try again, or use Back to Entrance.';
      }
    });
  }
})();
